var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1497_3028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3029 12.6051C15.1775 11.6539 14.5322 10.2635 14.5322 8.79055V6.7154C14.5322 4.09617 12.5866 1.92799 10.0663 1.56477V0.760913C10.0663 0.349309 9.73288 0.0166016 9.32202 0.0166016C8.91116 0.0166016 8.57771 0.349309 8.57771 0.760913V1.56477C6.05673 1.92799 4.11184 4.09617 4.11184 6.7154V8.79055C4.11184 10.2635 3.46652 11.6539 2.33442 12.6111C2.04489 12.859 1.87891 13.2192 1.87891 13.6003C1.87891 14.3185 2.46319 14.9028 3.18145 14.9028H15.4626C16.1809 14.9028 16.7651 14.3185 16.7651 13.6003C16.7651 13.2192 16.5992 12.859 16.3029 12.6051Z",
    fill: "url(#paint0_linear_1497_3028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32054 17.8801C10.6685 17.8801 11.7961 16.9192 12.0551 15.6472H6.58594C6.84496 16.9192 7.97259 17.8801 9.32054 17.8801Z",
    fill: "url(#paint1_linear_1497_3028)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1497_3028",
    x1: 0.87236,
    y1: 12.4139,
    x2: 16.7918,
    y2: 0.0238816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1497_3028",
    x1: 6.21613,
    y1: 17.5067,
    x2: 8.24283,
    y2: 13.6433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1497_3028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8635,
    height: 17.8635,
    fill: "white",
    transform: "translate(0.390625 0.0166016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "assets/media/bell-icon.da7f7ca8d4e61fc6309160a14a8202dc.svg";
export { ForwardRef as ReactComponent };